// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"ae2a2a35","180":"081f779a","208":"8e77f7ad","774":"01dfa7a2","787":"393c5b17","814":"96196eda","820":"676f5763","851":"f1bb604e","916":"8effd2cf"}[chunkId] + ".chunk.js";
};